<template>
<div>
  <nav class="navbar navbar-expand navbar-dark bg-dark">
    <div class="container">
      <a class="navbar-brand" id="nav-principal" href="http://www.apa-pablo-picasso.es">AMPA Pablo Picasso</a>
    </div>
  </nav>

  <div class="row justify-content-center">
    <div class="col-md-4 col-12">
      <div class="card mt-5">
        <h5 class="card-header">Cambio de contraseña</h5>
        <div class="card-body">

          <form class="form-horizontal" id="cambiar-password" action="" @submit.stop.prevent="enviarPassword" novalidate>

          <!--
          <div class="form-group row">
            <label class="col-5 col-form-label" for="actual">Contraseña actual</label>
            <div class="col-7">
              <input id="actual" name="actual" type="password" class="form-control">
            </div>
          </div>
          -->

          <div class="form-group row">
            <label class="col-5 col-form-label" for="password1">Nueva contraseña</label>
            <div class="col-7">
              <input id="pin-nuevo1" name="password1" type="password" class="form-control" :class="validarCampo(password1)" v-model="password1" required>
              <div class="invalid-feedback">Debes introducir una contraseña</div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-5 col-form-label" for="password2">Repetir contraseña</label>
            <div class="col-7">
              <input id="password2" name="password2" type="password" class="form-control" :class="validarCampo(validarPassword(password1, password2))" v-model="password2" required>
              <div class="invalid-feedback">Las dos contraseñas deben ser iguales</div>
            </div>
          </div>

          <p class="text-right"><button type="submit" class="btn btn-primary">Cambiar</button></p>

          <div>{{ mensajeError }}</div>

          </form>

        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>

import { api } from '../api/api.js';
import { validarPassword } from '../validacion.js';

export default {
	name: 'CambiarPassword',
	props: ['token'],
	data() {
		return {
			validado: false,
			password1: null,
			password2: null,
			mensajeError: '',
		}
	},
	methods: {
		validarPassword,
		validarCampo(condicion) {
			if (! this.validado) {
				return '';
			}
			if (condicion) {
				return 'is-valid';
			} else {
				return 'is-invalid';
			}
		},
		enviarPassword(e) {
			if (! validarPassword(this.password1, this.password2) || ! e.target.checkValidity()) {
				this.validado = true;
				return;
			}
			this.validado = false;
			const data = {
				'token': this.token,
				'password': this.password1,
			}
			api('/acceso/cambiar', 'PUT', data)
				.then((data) => {
					if (data.resultado) {
						this.$router.push('/acceso')
					} else {
						this.mensajeError = data.error;
					}
				}
			);
		},
	}
}
</script>
